<template>
  <div>
    <t-loading v-model="loading" />
    <div class="pt-4 px-4">
      <v-row class="justify-space-between mb-2 mt-6">
        <v-col cols="12" md="10" class="d-flex">
          <v-btn
            icon
            color="primary"
            :to="{name: 'facturacion'}"
            exact
          >
            <v-icon left medium>mdi-arrow-left</v-icon>
          </v-btn>
          <p style="color: #4477ad; font-size: 26px">
            {{ $t('billing') + ' ' + (getData.TRANSACTION_NUMBER || '').replace('VE', '').trim() }}
          </p>
        </v-col>
      </v-row>
      <v-card class="pa-6">
        <v-row style="width: 95%" class="ma-auto">

          <v-col cols="12" md="4">
            <header-details-row 
              :label="$t('billingNumber')" 
              :data="getData.TRANSACTION_NUMBER"
            />
          </v-col>
          <v-col cols="12" md="4">
            <header-details-row 
              :label="$t('purchaseOrder')" 
              :data="getData.CUSTOMER_PO"
            />
          </v-col>
          <v-col cols="12" md="4">
            <header-details-row 
              :label="$t('fiscalCode')" 
              :data="getData.FISCAL_CODE"
            />
          </v-col>
          <v-col cols="12" md="4">
            <header-details-row 
              :label="$t('customer')" 
              :data="getData.CUSTOMER"
            />
          </v-col>
          <v-col cols="12" md="4">
            <header-details-row 
              :label="$t('salesPerson')" 
              :data="getData.SALESPERSON"
            />
          </v-col>                    

          <v-col cols="12" md="4">
            <header-details-row 
              :label="$t('orderedDate')"               
            >
              <data-table-date-only-column :value="getData.ORDERED_DATE" />
            </header-details-row>
          </v-col>
          <v-col cols="12" md="4">
            <header-details-row 
              :label="$t('billingDate')" 
            >
              <data-table-date-only-column :value="getData.DATE_BILLING" />
            </header-details-row>
          </v-col>
          <v-col cols="12" md="4">
            <header-details-row 
              :label="$t('paymentTerm')" 
              :data="getData.PAYMENT_TERM"
            />
          </v-col>   

          <v-col cols="12" md="4">
            <header-details-row 
              :label="$t('carrier')" 
              :data="getData.CARRIER"
            />
          </v-col>
          <v-col cols="12" md="4" v-if="validateCountryInfo()">
            <header-details-row 
              :label="$t('shippingLocation')" 
              :data="getData.SHIPPING_INSTRUCTIONS"
            />
          </v-col>
          <v-col cols="12" md="4" v-else>
            <header-details-row 
              :label="$t('shippingLocation')" 
              :data="getData.SHIP_LOCATION"
            />
          </v-col>
          <v-col cols="12" md="4">
            <header-details-row 
              :label="$t('shipCity')" 
              :data="getData.SHIP_CITY"
            />
          </v-col>
          <v-col cols="12" md="4">
            <header-details-row>
              <data-table-currency-column
                  :before="$t('subtotal') + ': '"
                  :value="getData.SUBTOTAL"
                  :options="{ prefix: '$', decimals: VUE_APP_DECIMALS }"
              />
              <data-table-currency-column
                  :before="$t('taxes') + ': '"
                  :value="getData.TAXES"
                  :options="{ prefix: '$', decimals: VUE_APP_DECIMALS }"
              />
              <data-table-currency-column
                  :before="$t('total') + ': '"
                  :value="getData.TOTAL"
                  :options="{ prefix: '$', decimals: VUE_APP_DECIMALS }"
              />
            </header-details-row>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="my-8 pb-4 d-flex flex-column flex-grow-0 scroll-y" height="100%"> 
        <list-billing-items-component class="pa-0 reset-listview" :details="details" />
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ListBillingItemsComponent from './components/ListBillingItemsComponent.vue'
// import FacturacionTrackingComponent from './components/FacturacionTrackingComponent.vue'
import DataTableDateOnlyColumn from '../../arch/components/data-table/columns/DataTableDateOnlyColumn.vue'
import mixinAlert from '@/mixins/mixinAlert'
import HeaderDetailsRow from '@/arch/components/HeaderDetailsRow.vue'
import { VUE_APP_DECIMALS, VUE_APP_COUNTRY } from '@/config'

export default {
  name: 'ViewFacturacionDetails',
  mixins: [mixinAlert],
  components: {
    ListBillingItemsComponent,
    // FacturacionTrackingComponent,
    DataTableDateOnlyColumn,
    HeaderDetailsRow,
  },
  props: {
    parent: {
      type: Object,
      default() {
        return {}
      },
    }
  },
  data() {
    return {
      loading: false,
      details: [],
    }
  },
  methods: {
    async getBillingData() {
      this.loading = true
      const result = await this.setDetailsDataToList(this.parent.INVOICE  || this.$route.params.id)
      this.loading = false
      if (result instanceof Error) {
        await this.mixinAlertError()
        return
      }
      this.details = this.getDetailsList;
    },
    emptyString(string) {
      return string ? string.trim() || ' - ' : ' - ';
    },
    VUE_APP_DECIMALS() {
      return VUE_APP_DECIMALS
    },
    ...mapActions({
      setDetailsDataToList(dispatch, payload) {
        return dispatch('facturacionStore/setDetailsDataToList', payload)
      },      
    }),
    validateCountryInfo(){
      if(VUE_APP_COUNTRY == 'EC'){
        return true;
      }
    }
  },
  computed: {
    ...mapState({
      getData(_, getters) {
        return getters['facturacionStore/getData']
      },
      getDetailsList(_, getters) {
        return getters['facturacionStore/getDetailsList']
      },      
    }),
    VUE_APP_DECIMALS() {
      return VUE_APP_DECIMALS
    }
  },
  async mounted() {
    await this.getBillingData();
  }
}
</script>
